<template>
  <div>
    <k-form :columns="1" title="Form Details" icon="fas fa-memo-circle-info">
      <k-form-section :column-span="1">
        <k-form-field label="Review Type" :required="true" :field-id="'review-type-input'">
          <input id="review-type-input" class="form-control form-control" placeholder="Name" v-model="reviewType">
        </k-form-field>
        <k-text-editor v-model="description"
          label="Description"
          placeholder="Briefly describe the purpose of the meeting form"
          :required="true"
          :max-length="1024"
        ></k-text-editor>
      </k-form-section>
    </k-form>
    <h3>
      <i class="fas fa-pencil" aria-hidden="true"></i>
      Form Builder
    </h3>
    <questionnaire-prompt-list v-model="prompts"
      :response-options="responseOptions"
      :review-options="[]"
      :ai-features-supported="false"
      :new-prompt-default="newPromptDefault"
    ></questionnaire-prompt-list>
  </div>
</template>

<style scoped>
h3 {
  margin-top: 16px;
}
</style>

<script>
import {
  KForm, KFormSection, KFormField,
} from '@base-components/forms';
import TimeMixin from '@mixins/time-mixins';
import KTextEditor from '@base-components/k-text-editor.vue';
import QuestionnairePromptList from '../questionnaires/questionnaire_creation/questionnaire-prompt-list.vue';

const RESPONSE_OPTIONS = [
  { value: 'LONG_TEXT', name: 'Long text' },
  { value: 'SHORT_TEXT', name: 'Short text' },
  { value: 'MULTIPLE_CHOICE', name: 'Multiple choice' },
  { value: 'BKSB_SCORES', name: 'BKSB scores' },
  { value: 'OTJ_HOURS', name: 'OTJ hours' },
  { value: 'DATE', name: 'Date' },
  { value: 'YES_NO', name: 'Yes or No' },
];

export default {
  components: {
    KForm,
    KFormSection,
    KFormField,
    QuestionnairePromptList,
    KTextEditor,
  },

  mixins: [TimeMixin],

  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      reviewType: this.modelValue?.reviewType || '',
      description: this.modelValue?.description || '',
      prompts: this.modelValue?.prompts || [],
      responseOptions: RESPONSE_OPTIONS,
    };
  },

  mounted() {
    this.$emit('isValid', this.isValid);
  },

  watch: {
    reviewType(reviewType) {
      this.$emit('update:modelValue', { ...this.modelValue, reviewType });
      this.$emit('isValid', this.isValid);
    },
    description(description) {
      this.$emit('update:modelValue', { ...this.modelValue, description });
      this.$emit('isValid', this.isValid);
    },
    prompts: {
      handler(prompts) {
        this.$emit('update:modelValue', { ...this.modelValue, prompts });
        this.$emit('isValid', this.isValid);
      },
      deep: true,
    },
  },

  computed: {
    newPromptDefault() {
      return {
        prompt: 'Type your question here...',
        responseType: 'MULTIPLE_CHOICE',
        reviewType: null,
        answers: {
          choices: ['Type an answer here...', 'Type an answer here...'],
          choice_amount: 1,
        },
        number: this.prompts.length + 1,
      };
    },
    isValid() {
      if (!this.reviewType || !this.description) {
        return false;
      }
      if (this.prompts.length === 0) {
        return false;
      }
      if (this.description.length > 1024) {
        return false;
      }
      return this.prompts.every(prompt => {
        if (!prompt.prompt || !prompt.responseType) {
          return false;
        }
        if (prompt.responseType === 'MULTIPLE_CHOICE' && (!prompt.answers || !prompt.answers.choices || prompt.answers.choices.length < 2)) {
          return false;
        }
        if (prompt.responseType === 'MULTIPLE_CHOICE' && !prompt.answers.choices.every(choice => choice && choice.length > 0 && choice.length < 128)) {
          return false;
        }
        if (prompt.responseType === 'MULTIPLE_CHOICE' && (!prompt.answers.choice_amount || prompt.answers.choice_amount < 1 || prompt.answers.choice_amount > prompt.answers.choices.length)) {
          return false;
        }
        return prompt.prompt;
      });
    },
  },
};
</script>
